import { handleError, handleResponse } from "@/services/api/utils/response.js";
import { apiProvider } from "@/services/api/utils/provider.js";
import { ApiCore } from "@/services/api/utils/core.js";
import axios from "axios";

const url = "termTemplate";

const api = new ApiCore({
	index: true,
	url: url,
});

api.getModelTerms = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`)
		.then(handleResponse)
		.catch(handleError);
};

export default api;
